import { DesktopOTPVerificationPage } from '@/app/pages/DesktopOTPVerificationPage';

export function ResponsiveOTPVerificationPage() {
  return <DesktopOTPVerificationPage />;
}
